export class SyncMapper {
    mapContentItemDelta(itemDeltaContract) {
        return {
            changeType: itemDeltaContract.change_type,
            codename: itemDeltaContract.codename,
            collection: itemDeltaContract.collection,
            id: itemDeltaContract.id,
            language: itemDeltaContract.language,
            timestamp: itemDeltaContract.timestamp,
            type: itemDeltaContract.type
        };
    }
}
//# sourceMappingURL=sync.mapper.js.map